import PropTypes from 'prop-types';

const opinionLabelTypes = PropTypes.shape({
  label: PropTypes.string,
  labelDisplay: PropTypes.string,
  labelText: PropTypes.string,
  type: PropTypes.string,
  authors: PropTypes.arrayOf(PropTypes.object),
  entryId: PropTypes.string,
});

const headerComponentParams = PropTypes.shape({
  make: PropTypes.shape({ name: PropTypes.string, value: PropTypes.string }),
  model: PropTypes.shape({ name: PropTypes.string, value: PropTypes.string }),
  year: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  bodyType: PropTypes.string,
});

const highlightsComponentParams = PropTypes.shape({
  make: PropTypes.string,
  model: PropTypes.string,
  year: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  styleId: PropTypes.number,
  labels: PropTypes.arrayOf(PropTypes.string),
});

const editorialRatingType = PropTypes.shape({
  rating_enum: PropTypes.string,
  rating_number: PropTypes.string,
  submodel: PropTypes.string,
});

export const personalizedSearchEntities = {
  headerComponentParams,
  highlightsComponentParams,
  editorialRatingType,
  opinionLabelTypes,
};
